import { getSession, getssoLoginUrl } from '../services/user.js';
import { alertError } from '../utils/edittools.js';
import { responseCode, responseData } from '../types/domain.js';
import { isRecord } from './dva-types.js';
import type { ModelSaga, TypedModel } from './dva-types.js';

function isSessionWithSso(value: unknown): value is { sso?: Readonly<Record<string, unknown>> } {
  return (
    !(value instanceof Error) &&
    isRecord(value) &&
    (value['sso'] === undefined || isRecord(value['sso']))
  );
}

const model: TypedModel<Record<string, unknown>> = {
  namespace: 'platKsedu',
  state: {},
  subscriptions: {
    setup({ dispatch, history }) {
      history.listen(({ pathname }) => {
        window.scrollTo(0, 0);
        const hostParts = pathname.match(/\/sso\/(.+)/u);
        if (!hostParts?.length) return;
        const field = hostParts[1];
        if (field === 'admin' || field === 'web')
          dispatch({ type: 'ssoLogin', payload: { field } });
      });
    },
  },
  effects: {
    *ssoLogin({ payload }): ModelSaga {
      const { field = 'web' } = payload as { field?: 'admin' | 'web' };
      const currentSession = yield getSession();
      const apiSSO = isSessionWithSso(currentSession) ? currentSession.sso : undefined;
      if (!apiSSO) {
        alertError('没有发现本站有单点登录配置，请检查跳转站点域名是否一致');
        return;
      }
      const deploymentSlug = window.location.host;
      const sso = apiSSO[deploymentSlug];
      if (!sso) {
        alertError('请返回重试');
        return;
      }
      const result = yield getssoLoginUrl({ field, deploymentSlug, ssoSlug: window.location.host });
      if (responseCode(result) !== 0) {
        alertError(result instanceof Error ? result.message : '获取单点登录地址失败');
        return;
      }
      const requestURL = responseData<string>(result);
      if (requestURL) window.location.replace(requestURL);
    },
  },
  reducers: {
    update(state: Record<string, unknown>, { payload }: { payload: Record<string, unknown> }) {
      return { ...state, ...payload };
    },
  },
};

export default model;
